const multiplyMixBlendMode: { mixBlendMode: 'multiply' } = {
	mixBlendMode: 'multiply',
};

export const UniError = ({ title }: { title: string }) => (
	<div
		style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			width: '100%',
			height: '100%',
			paddingTop: 32,
		}}
	>
		<svg width="100%" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" style={{ display: 'block' }}>
			<title>{title}</title>
			<mask id="mask0_19090_12952" maskUnits="userSpaceOnUse" x="0" y="0" width="300" height="300">
				<circle cx="150" cy="150" r="150" fill="#D4E3FC" />
			</mask>
			<g mask="url(#mask0_19090_12952)">
				<circle cx="150" cy="150" r="150" fill="#D4E3FC" />
				<path
					d="M49.7692 139.986C10.6585 170.66 0.293623 224.749 0 247.959V264.706L96.4553 316.235V198.929C96.4553 211.404 106.568 221.517 119.044 221.517H147.546L162.961 234.297V241.427C162.961 246.495 167.069 250.603 172.137 250.603H198.636L209.647 221.517L150.188 116.629C133.011 111.634 88.8798 109.313 49.7692 139.986Z"
					fill="#F7F9FC"
				/>
				<path d="M149.647 82.5881V122.823C143.461 120.907 131.434 114.334 132.815 103.369C134.196 92.4038 144.612 84.9462 149.647 82.5881Z" fill="white" />
				<rect x="135.529" y="168.706" width="8.47059" height="10.5882" rx="4.23529" fill="#6BA6FF" />
				<g style={multiplyMixBlendMode}>
					<path
						d="M147.882 113.647H116.823C104.117 88.2353 67.0585 110.824 57.1761 122.824C47.2938 134.824 16.5879 132 20.4703 154.588C-8.89444 166.447 -10.118 198.471 -7.05914 209.294C2.11733 228 23.6467 264.282 36.3526 259.765C52.235 254.118 55.4115 233.294 47.6468 222C74.4703 222 80.1173 202.588 67.0585 193.765C68.235 196.941 67.9056 203.153 57.1762 202.588C43.7644 201.882 41.6468 174.353 63.5291 162C85.4115 149.647 100.588 160.235 121.059 126.706C125.529 126.941 135.953 144.776 139.059 149.294C147.882 162.706 166.588 166.588 185.647 158.47C175.411 162 176.823 149.647 173.647 139.412C171.106 131.223 162.706 113.647 147.882 113.647Z"
						fill="#FDAAAF"
					/>
				</g>
				<path d="M122.823 82.5881V122.823C116.38 120.907 103.852 114.334 105.29 103.369C106.729 92.4038 117.578 84.9462 122.823 82.5881Z" fill="white" />
				<path d="M229.411 60.7058L147.882 129.529C147.882 138.847 154.117 140.471 158.47 140.471L229.411 60.7058Z" fill="white" />
				<path d="M229.411 60.7058L147.882 129.529C147.882 138.847 154.117 140.471 158.47 140.471L229.411 60.7058Z" fill="white" />
				<path
					d="M206.287 115.898L179.088 83.8985C178.177 82.8271 178.193 81.2488 179.126 80.1967L191.553 66.181C192.691 64.897 194.702 64.917 195.815 66.2232L223.366 98.5656C224.297 99.6584 224.26 101.276 223.279 102.325L210.501 115.997C209.349 117.23 207.38 117.183 206.287 115.898Z"
					fill="#656C7B"
				/>
				<path
					d="M207.054 114.082L180.752 83.1879C180.186 82.5229 180.192 81.5439 180.765 80.8852L190.882 69.2652C191.59 68.452 192.855 68.4583 193.555 69.2785L220.229 100.537C220.811 101.219 220.789 102.229 220.177 102.885L209.689 114.141C208.969 114.913 207.738 114.885 207.054 114.082Z"
					fill="#ADCEFF"
				/>
				<path
					d="M197.056 89.3299L195.718 85.1583L196.621 83.2694L193.912 81.8528M199.783 88.9361V85.6306H201.792M201.589 92.2417L205.654 94.1306V96.0194H207.912M200.238 92.5991V96.5222L202.492 98.8528"
					stroke="white"
					strokeOpacity="0.57"
					strokeWidth="0.705882"
					strokeLinecap="round"
				/>
				<path
					d="M203.997 90.1952C204.186 90.1479 204.301 89.9563 204.254 89.7672C204.207 89.5781 204.015 89.4631 203.826 89.5104L203.997 90.1952ZM199.912 90.8528L199.997 91.1952L203.997 90.1952L203.912 89.8528L203.826 89.5104L199.826 90.5104L199.912 90.8528Z"
					fill="white"
					fillOpacity="0.57"
				/>
				<path d="M194.912 89.8528L193.093 86.8528L190.912 87.6028" stroke="white" strokeOpacity="0.57" strokeWidth="0.705882" strokeLinecap="round" />
				<g style={multiplyMixBlendMode}>
					<path
						d="M79.0583 94.5884C82.7573 96.6177 85.2921 100.335 85.4929 104.631C89.3139 102.657 93.8009 102.994 97.4079 105.183C97.4999 109.401 95.5473 113.455 91.9265 115.777C95.5476 118.099 97.501 122.153 97.4089 126.372C93.8014 128.561 89.3133 128.897 85.4919 126.921C85.2913 131.218 82.7574 134.936 79.0583 136.965C75.359 134.936 72.8249 131.217 72.6247 126.92C68.8034 128.895 64.316 128.56 60.7087 126.371C60.6167 122.153 62.569 118.099 66.1892 115.777C62.5686 113.455 60.6166 109.4 60.7087 105.182C64.3156 102.993 68.8027 102.657 72.6237 104.631C72.8245 100.335 75.3595 96.6177 79.0583 94.5884Z"
						fill="#FFB300"
					/>
				</g>
				<path
					d="M197.167 87.9236C199.141 88.1886 201.344 89.1775 201.804 91.7458L158.471 140.47C154.118 140.47 147.882 138.847 147.882 129.529L197.167 87.9236Z"
					fill="white"
				/>
				<path
					d="M189.882 224.471C188.471 222.212 185.294 223.059 183.882 223.765C186.706 223.765 188.824 228 186.706 231.529C189.529 230.824 191.647 227.294 189.882 224.471Z"
					fill="#DBE1E6"
				/>
				<path
					d="M139.765 169.412V169.412C135.294 169.412 131.86 173.371 132.492 177.797L132.706 179.294"
					stroke="#6BA6FF"
					strokeWidth="1.41176"
					strokeLinecap="round"
				/>
			</g>
		</svg>
	</div>
);
